// extracted by mini-css-extract-plugin
export var social_media_links = "styles-module--social_media_links--37be8";